export default __webpack_public_path__ + "static/media/icon_mtrg.1d2c407a.svg";